/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Data_Storage_AppInputs */

const en_ui_data_storage_app = /** @type {(inputs: Ui_Data_Storage_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App data`)
};

const de_ui_data_storage_app = /** @type {(inputs: Ui_Data_Storage_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App-Daten`)
};

/**
* | output |
* | --- |
* | "App data" |
*
* @param {Ui_Data_Storage_AppInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_data_storage_app = /** @type {((inputs?: Ui_Data_Storage_AppInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Data_Storage_AppInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_data_storage_app(inputs)
	return de_ui_data_storage_app(inputs)
});